import { Mail, CheckCircle2, XCircle, Filter, Zap } from 'lucide-react'
import { TagLabel } from '@/components/ui/tag-label'

interface WorkflowStatsProps {
  emailsProcessed: number
  emailsMatched: number
  emailsFailed: number
  matchRate: number
  failRate: number
  filtersCount?: number
  actionsCount?: number
  showFiltersAndActions?: boolean
}

export default function WorkflowStats({
  emailsProcessed,
  emailsMatched,
  emailsFailed,
  matchRate,
  failRate,
  filtersCount,
  actionsCount,
  showFiltersAndActions = false,
}: WorkflowStatsProps) {
  const formatNumber = (num: number) => {
    return num.toLocaleString()
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      <TagLabel
        leftIcon={<Mail className="w-3 h-3" />}
        className="px-1.5 py-1 rounded-sm"
      >
        {formatNumber(emailsProcessed)} processed
      </TagLabel>
      <TagLabel
        leftIcon={<CheckCircle2 className="w-3 h-3" />}
        className="px-1.5 py-1 rounded-sm"
      >
        {formatNumber(emailsMatched)} matched ({matchRate}%)
      </TagLabel>
      {emailsFailed > 0 && (
        <TagLabel
          leftIcon={<XCircle className="w-3 h-3" />}
          className="px-1.5 py-1 rounded-sm"
        >
          {formatNumber(emailsFailed)} failed ({failRate}%)
        </TagLabel>
      )}
      {showFiltersAndActions && filtersCount !== undefined && (
        <TagLabel
          leftIcon={<Filter className="w-3 h-3" />}
          className="px-1.5 py-1 rounded-sm"
        >
          {formatNumber(filtersCount)} {filtersCount === 1 ? 'filter' : 'filters'}
        </TagLabel>
      )}
      {showFiltersAndActions && actionsCount !== undefined && (
        <TagLabel
          leftIcon={<Zap className="w-3 h-3" />}
          className="px-1.5 py-1 rounded-sm"
        >
          {formatNumber(actionsCount)} {actionsCount === 1 ? 'action' : 'actions'}
        </TagLabel>
      )}
    </div>
  )
}
